import { UploadFail } from './UploadFail';

export class FileReaderError extends UploadFail {
    radarName = 'filereader_fail';
    message = 'Не удалось прочитать файл.';
}
